import { render, staticRenderFns } from "./battle-box.vue?vue&type=template&id=5cb1a8e4&scoped=true&"
import script from "./battle-box.vue?vue&type=script&lang=js&"
export * from "./battle-box.vue?vue&type=script&lang=js&"
import style0 from "./battle-box.vue?vue&type=style&index=0&id=5cb1a8e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb1a8e4",
  null
  
)

export default component.exports